// src/components/customers/CustomerFilterBar.js
import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

const CustomerFilterBar = ({ searchTerm, setSearchTerm, filterProgram, setFilterProgram, availablePrograms }) => {
    return (
        <div className="bg-white rounded-lg shadow-md p-4 flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-4 mb-6">
            {/* Search Input */}
            <div className="relative w-full md:w-1/2">
                <input
                    type="text"
                    placeholder="Search by name or email..."
                    className="w-full pl-10 pr-4 py-2 rounded-lg bg-gray-100 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent text-gray-700"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
            </div>

            {/* Filter by Loyalty Program */}
            <div className="w-full md:w-auto">
                <label htmlFor="programFilter" className="sr-only">Filter by Program</label>
                <select
                    id="programFilter"
                    value={filterProgram}
                    onChange={(e) => setFilterProgram(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent"
                >
                    {availablePrograms.map(program => (
                        <option key={program} value={program}>{program}</option>
                    ))}
                </select>
            </div>

            {/* Add more filters here if needed (e.g., by status, points range) */}
        </div>
    );
};

export default CustomerFilterBar;